import { useShowSuccess, useShowError } from 'hooks/useToast'
import { useUpdateStorePartMutation } from '../../../graphql/'

export default function useUpdateStorePartHandler() {
	const [ updateStorePart ] = useUpdateStorePartMutation()
	const showSuccess = useShowSuccess()
	const showError = useShowError()

	return async( storePart: {
		storePartId: number,
		cost: number | null,
		threshold: number | null,
		max: number | null,
		location: string,
		note: string,
	} ) => {
		const { storePartId, cost, location, max, note, threshold } = storePart

		const variables = {
			storePartId,
			cost,
			threshold,
			max,
			location,
			note,
		}

		const result = await updateStorePart( { variables } )

		if ( result.data?.updateStorePart?.success ) {
			showSuccess( `updateStorePartSuccess${Date.now()}`, result.data?.updateStorePart?.message ?? 'Successfully updated store part!' )
		} else {
			showError( `updateStorePartError${Date.now()}`, result.data?.updateStorePart?.message ?? 'Sorry, an error occurred' )
		}
	}
}
